export default function NotFound() {
  return (
    <div className="justify-center w-full h-screen">
      <p className="mt-20 text-4xl text-center">🚧</p>
      <p className="mt-2 font-semibold text-center text-stone-200">
        This page is under-construction
      </p>
    </div>
  );
}
